<template>
  <div v-if="showedItems && showedItems.length" class="projects grid-x grid-margin-x align-top">
    <work v-bind:data-cat="item.type" v-for="(item, key) of showedItems" :key="key" :work="item" />
  </div>
</template>

<script>
import Work from "../single/Work";
import { mapGetters } from "vuex";

export default {
  components: {
    Work
  },
  props: {
    payload: {
      default: () => {}
    },
    items: {
      default: () => []
    }
  },
  mounted() {
    if (!this.items || !this.items.length) {
      let query = "?limit=100000";
    if (this.payload.type === "category") {
      query = `&type=${this.payload.selectedCategory}`;
    } else if (this.payload.type === "selection") {
      query = "&ids=" + this.payload.selectedWorks.join(",");
    }
    this.$store.dispatch("getWorks", query);
    }
  },
  computed: {
    ...mapGetters({
      works: "getWorks"
    }),
    showedItems() {
      if (this.items && this.items.length) {
        return this.items
      }
      return this.works
    }
  }
};
</script>
